export default "__VITE_ASSET__DWW86GSY__"